export class MfkFieldName {
  static FUND = 'FUND';
  static ORG = 'ORG';
  static DEPT = 'DEPT';
  static SUBDEPT = 'SUBDEPT';
  static GRANTPGM = 'GRANTPGM';
  static IACT = 'IACT';
  static OACT = 'OACT';
  static DACT = 'DACT';
  static FN = 'FN';
  static CCTR = 'CCTR';
  static BRF = 'BRF';
}
